import { createFileRoute } from '@tanstack/react-router';
import { JobDetailPage } from '../components/community/JobDetailPage';

export const Route = createFileRoute('/community/jobs/$jobId')({
  component: JobDetailPage,
  beforeLoad: ({ params }) => {
    console.log('=== Rota /community/jobs/$jobId beforeLoad ===');
    console.log('jobId recebido:', params.jobId);
    if (params.jobId === 'new') {
      console.error('ERRO: A rota $jobId está capturando "new" como parâmetro!');
    }
  },
});
